module.exports = __webpack_public_path__ + "img/NZ.587916ca.png";